import React from 'react'

/**
 * MappedFilters Component
 * 
 * This component receives an array of strings and displays them in a single line, 
 * separated by a vertical bar (|) with spacing. A left border is added starting from the second item.
 * 
 * @param {Object} props - Component props
 * @param {string[]} props.data - An array of strings to be displayed
 * @returns {JSX.Element} - Rendered component
 */
export const MappedFilters = ({ data }: { data: string[] }) => {
    return (
        <div style={{ display: "flex", gap: "8px" }}>
            {data.map((item, index) => (
                <span
                    key={index}
                    style={{
                        paddingLeft: index > 0 ? "8px" : "0",
                        borderLeft: index > 0 ? "1px solid #ccc" : "none",
                    }}
                >
                    {item}
                </span>
            ))}
        </div>
    );
};